import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { FaEye, FaHeart } from 'react-icons/fa';
import { MdOutlineMenuBook } from 'react-icons/md';
import api from '../services/api';
import '../styles/CategoryPage.css';
import getBookCoverUrl from '../utils/getBookCoverUrl';

function CategoryPage() {
  const { categoryId } = useParams();
  const [books, setBooks] = useState([]);
  const [category, setCategory] = useState(null);
  const [categoryName, setCategoryName] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }

    const fetchData = async () => {
      setLoading(true);
      setError(null);

      try {
        const categoryResponse = await api.get(`/categories/${categoryId}`, {
          headers: { Authorization: `Bearer ${token}` },
        });

        if (categoryResponse.data) {
          setCategory(categoryResponse.data);
          setCategoryName(categoryResponse.data.name);
        } else {
          setCategoryName("Kategori");
        }

        try {
          const booksResponse = await api.get(`/categories/${categoryId}/books`, {
            headers: { Authorization: `Bearer ${token}` },
          });

          const updatedBooks = Array.isArray(booksResponse.data)
            ? booksResponse.data.map((book) => ({
                ...book,
                cover_image_url: getBookCoverUrl(book.cover_image_url)
              }))
            : [];

          setBooks(updatedBooks);
        } catch (bookError) {
          setBooks([]);
        }
      } catch (error) {
        setError("Kategori bulunamadı.");
        setCategoryName("Kategori");
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [categoryId, navigate]);

  const handleBookClick = (bookId) => {
    navigate(`/book/${bookId}`);
  };

  if (loading) {
    return <div className="category-loading">Yükleniyor...</div>;
  }

  return (
    <div className="category-page">
      <h1 className="category-page-title">
        {category ? `${category.name} Kategorisindeki Kitaplar` : `${categoryName} Kategorisindeki Kitaplar`}
      </h1>

      {category && category.description && (
        <p className="category-page-description">{category.description}</p>
      )}

      {error && <div className="category-error-message">{error}</div>}

      <div className="category-book-grid">
        {books && books.length > 0 ? books.map((book, index) => (
          <div
            key={book.book_id}
            className={`category-book-card ${index % 2 === 0 ? "category-left-item" : "category-right-item"}`}
            onClick={() => handleBookClick(book.book_id)}
          >
            <div className="category-book-cover-container">
              <img
                src={book.cover_image_url || '/images/default-book-cover.jpg'}
                alt={book.title}
              />
            </div>
            <h2 className="category-book-title">{book.title}</h2>
            <p className="category-book-author">{book.author}</p>
            <div className="category-book-stats">
              <span><FaEye /> {book.total_views}</span>
              <span><FaHeart /> {book.total_likes}</span>
              <span><MdOutlineMenuBook /> {book.chapter_count}</span>
            </div>
          </div>
        )) : (
          <p className="category-no-books-message">Bu kategoride kitap bulunmamaktadır.</p>
        )}
      </div>
    </div>
  );
}

export default CategoryPage;